// [init]
import auth from '../../restricted/Auth'
export default {


	namespaced: true,

	state: {
		// Listing of all customers ( Array )
		customersList: [],
		sendcreditList: [],
		receivedcreditList: [],
		// Current Customer being manipulated ( viewed or edited ) ( Object )
		status: '',
		activeCustomer: {}
	},

	mutations: {

		///

		storeUserData(state, params) {


			// Store all user properties.

			for (var key in params) state[key] = params[key];
			state.jwt = params.jwt;


			// Set user as signed-in.

			state.isSignedIn = true;


			// Instruct Axios to add the `Authorization` header for all requests from this point.

			global.axios.defaults.headers.common['Authorization'] = 'Bearer ' + state.jwt;


			// Store JWT in localStorage/sessionStorage.

			if (params.staySignedIn) localStorage.setItem('params', JSON.stringify(state));
			else sessionStorage.setItem('params', JSON.stringify(state));


		},
		//

		// Update customerList with new list
		// @params: Array
		updateCustomerList(state, newList) {
			state.customersList = newList;
		},

		///
		updatesendcreditList(state, newList) {
			state.sendcreditList = newList;
		},
		///
		updatereceivedcreditList(state, newList) {
			state.receivedcreditList = newList;
		},
		///
		// Add a customer into customerList
		addCustomer(state, newCustomer) {
			state.customersList.push(newCustomer);
		},
		//
		addsendcreditList(state, sendcreditList) {
			state.sendcreditList.push(sendcreditList);
		},
		//


		addreceivedcreditList(state, receivedcreditList) {
			state.receivedcreditList.push(receivedcreditList);
		},
		// Delete a customer from customerList
		// @params: identifier (String)
		deleteCustomer(state, identifier) {
			state.customersList = state.customersList.filter(customer => {
				return customer.id != identifier;
			});
		},

		// Update the current active Customer object
		// @params: newActiveCustomer (Object)
		updateActiveCustomer(state, newActiveCustomer) {
			state.activeCustomer = newActiveCustomer;
		},

		// Change status of customerForm
		// @params: newStatus (String)
		updateStatus(state, newStatus) {
			state.status = newStatus;
		},

		resetState(state) {
			state.status = '';
			state.activeCustomer = {};
		},
		resetStateIndex(state) {
			state.customersList = [],
			state.sendcreditList = [],
			state.receivedcreditList = []
		},

	},

	actions: {

		/* 
		 *  /GET customers API
		 *  Get all customers from the server
		 *  @return: Array
		 */


		checkpromocode({ commit, state }, data) {

			return new Promise((resolve, reject) => {

				const postData = {
					code: data.code,
					package_id: data.packageID,
					customer_id: data.customerID,
					auth: data.auth
				};

				global.axios.request({
						method: 'post',
						url: '/customers/checkpromocode',
						data: postData,
						validateStatus: (status) => {
							return status == 200;
						}
					})
					.then(response => {
						resolve(response);
					})
					.catch(error => reject(error));

			});

		},
		//

		sendcreditList({ commit, state }) {
			return new Promise((resolve, reject) => {


				global.axios.request({
						method: 'post',
						url: '/customers/sendcreditList',
						validateStatus: (status) => {
							return status == 200;
						}
					})
					.then(response => {
						commit('updatesendcreditList', response.data);
						console.log(response);
						resolve(response);
					})
					.catch(error => reject(error));

			});

		},
		//
		receivedcreditList({ commit, state }) {
			return new Promise((resolve, reject) => {


				global.axios.request({
						method: 'post',
						url: '/customers/receivedcreditList',
						validateStatus: (status) => {
							return status == 200;
						}
					})
					.then(response => {
						commit('updatereceivedcreditList', response.data);
						console.log(response);
						resolve(response);
					})
					.catch(error => reject(error));

			});

		},

		// send credit
		sendcredit({ commit, state }, data) {
			return new Promise((resolve, reject) => {
				const postData = {
					amount: data.amount,
					email: data.email,
					email_type: data.emailType
				};

				global.axios.request({
						method: 'post',
						url: '/customers/sendcredit',
						data: postData,
						validateStatus: (status) => {
							return status == 200;
						}
					})
					.then(response => {
						commit('addsendcreditList', response.data[0]);
						resolve(response);
					})
					.catch(error => reject(error));

			});
		},
		// receivedcredit
		receivedcredit({ commit, state }, data) {
			return new Promise((resolve, reject) => {
				const postData = {
					code: data.code,
				};

				global.axios.request({
						method: 'post',
						url: '/customers/receivedcredit',
						data: postData,
						validateStatus: (status) => {
							return status == 200;
						}
					})
					.then(response => {
						commit('addreceivedcreditList', response.data[0]);
						resolve(response);
					})
					.catch(error => reject(error));

			});

		},



		getCustomers({ commit, state }) {

			return new Promise((resolve, reject) => {

				global.axios.request({
						method: 'get',
						url: '/customers',
						params: {
							trash: this.state.auth.type == 'admin' ? '*' : '0',
							from: 0,
							size: 9999999
						},
						validateStatus: (status) => {
							return status == 200;
						}
					})
					.then(response => {
						commit('updateCustomerList', response.data);
						resolve(response);
					})
					.catch(error => reject(error));

			});

		},

		///

		checkstatus({ commit, state }) {

			return new Promise((resolve, reject) => {

				global.axios.request({
						method: 'get',
						url: '/customers/checkstatus',

						validateStatus: (status) => {
							return status == 200;
						}
					})
					.then(response => {
						resolve(response.data);
					})
					.catch(error => reject(error));

			});

		},
		///

		/* 
		 *  /GET/:id customers API
		 *  Get a single customer from the server
		 *  @params: Array (due to vuex limitations)
		 *  [0]: identifier (String)
		 *  [1]: action (String: view/edit)
		 *  @return: Object
		 */
		getSingleCustomer({ commit, state }, params) {

			const identifier = params[0];
			const action = params[1];

			return new Promise((resolve, reject) => {

				global.axios.request({
						method: 'get',
						url: '/customers/' + identifier,
						validateStatus: (status) => {
							return status == 200;
						}
					})
					.then(response => {
						commit('updateActiveCustomer', response.data);
						commit('updateStatus', action);
						resolve(response);
					})
					.catch(error => reject(error));

			});

		},

		/* 
		 *  /POST customers API
		 *  Add a new customer to the server
		 *  @params: Object (customers data)
		 *  @return: Object
		 */
		addCustomer({ commit, state }, data) {

			return new Promise((resolve, reject) => {

				var credits = [];
				data.creditsLeft = 0;
				if(data.creditsMeta.p27 >= 0) {
					credits.push(Object.assign({}, { perHour: 27, numCredits: data.creditsMeta.p27 }));
					data.creditsLeft += Number.parseInt(data.creditsMeta.p27);
				}
				if(data.creditsMeta.p25 >= 0) {
					credits.push(Object.assign({}, { perHour: 25, numCredits: data.creditsMeta.p25 }));
					data.creditsLeft += Number.parseInt(data.creditsMeta.p25);
				}
				if(data.creditsMeta.p24 >= 0) {
					credits.push(Object.assign({}, { perHour: 24, numCredits: data.creditsMeta.p24 }));
					data.creditsLeft += Number.parseInt(data.creditsMeta.p24);
				}
				if(data.creditsMeta.p0 >= 0) {
					credits.push(Object.assign({}, { perHour: 0, numCredits: data.creditsMeta.p0 }));
					data.creditsLeft += Number.parseInt(data.creditsMeta.p0);
				}

				const postData = {
					mobile: '65' + data.mobile,
					salutation: data.salutation,
					firstname: data.firstname,
					lastname: data.lastname,
					email: data.email,
					creditsLeft: data.creditsLeft,
					otpVerified: data.otpVerified,
					credits: credits
				};

				global.axios.request({
						method: 'post',
						url: '/customers',
						validateStatus: (status) => {
							return status == 201;
						},
						data: postData
					})
					.then(response => {
						commit('addCustomer', response.data);
						resolve(response);
					})
					.catch(error => reject(error));

			});

		},

		/* 
		 *  /POST/:id customers API
		 *  Edits an existing customer into the server
		 *  @params: Object (customers data)
		 *  @return: Object
		 */
		editCustomer({ commit, state }, data) {
			return new Promise((resolve, reject) => {
				var credits = [];
				if (data.creditsMeta !== undefined) {
					data.creditsLeft = 0;
					if(data.creditsMeta.p27 > 0 || data.credits.map(function(e) { return e.perHour; }).indexOf(27) > -1) {
						credits.push(Object.assign({}, { perHour: 27, numCredits: data.creditsMeta.p27 }));
						data.creditsLeft += Number.parseInt(data.creditsMeta.p27);
					}
					if(data.creditsMeta.p25 > 0 || data.credits.map(function(e) { return e.perHour; }).indexOf(25) > -1) {
						credits.push(Object.assign({}, { perHour: 25, numCredits: data.creditsMeta.p25 }));
						data.creditsLeft += Number.parseInt(data.creditsMeta.p25);
					}
					if(data.creditsMeta.p24 > 0 || data.credits.map(function(e) { return e.perHour; }).indexOf(24) > -1) {
						credits.push(Object.assign({}, { perHour: 24, numCredits: data.creditsMeta.p24 }));
						data.creditsLeft += Number.parseInt(data.creditsMeta.p24);
					}
					if(data.creditsMeta.p0 > 0 || data.credits.map(function(e) { return e.perHour; }).indexOf(0) > -1) {
						credits.push(Object.assign({}, { perHour: 0, numCredits: data.creditsMeta.p0 }));
						data.creditsLeft += Number.parseInt(data.creditsMeta.p0);
					}
					for (var i = 0, len = data.creditsMeta.pOthers.length; i < len; i++) {
						if(data.creditsMeta.pOthers[i].removed == 0) {
							credits.push(Object.assign({}, { perHour: data.creditsMeta.pOthers[i].perHour, numCredits: data.creditsMeta.pOthers[i].numCredits }));
							data.creditsLeft += Number.parseInt(data.creditsMeta.pOthers[i].numCredits);
						}
					}
				}

				const postData = {
					mobile: '65' + data.mobile,
					salutation: data.salutation,
					firstname: data.firstname,
					lastname: data.lastname,
					email: data.email,
					creditsLeft: data.creditsLeft,
					otpVerified: data.otpVerified,
					credits: credits
				};
				
				global.axios.request({
						method: 'post',
						url: '/customers_admin/' + data.id + '/update',
						validateStatus: (status) => {
							return status == 200;
						},
						data: postData
					})
					.then(response => {
						commit('addCustomer', response.data);
						resolve(response);
					})
					.catch(error => reject(error));

			});

		},

		editCustomerUser({ commit, state }, data) {
			return new Promise((resolve, reject) => {
				var credits = [];
				if (data.creditsMeta !== undefined) {
					data.creditsLeft = 0;
					if(data.creditsMeta.p27 > 0) {
						credits.push(Object.assign({}, { perHour: 27, numCredits: data.creditsMeta.p27 }));
						data.creditsLeft += Number.parseInt(data.creditsMeta.p27);
					}
					if(data.creditsMeta.p25 > 0) {
						credits.push(Object.assign({}, { perHour: 25, numCredits: data.creditsMeta.p25 }));
						data.creditsLeft += Number.parseInt(data.creditsMeta.p25);
					}
					if(data.creditsMeta.p24 > 0) {
						credits.push(Object.assign({}, { perHour: 24, numCredits: data.creditsMeta.p24 }));
						data.creditsLeft += Number.parseInt(data.creditsMeta.p24);
					}
					if(data.creditsMeta.p0 > 0) {
						credits.push(Object.assign({}, { perHour: 0, numCredits: data.creditsMeta.p0 }));
						data.creditsLeft += Number.parseInt(data.creditsMeta.p0);
					}
					for (var i = 0, len = data.creditsMeta.pOthers.length; i < len; i++) {
						if(data.creditsMeta.pOthers[i].removed == 0) {
							credits.push(Object.assign({}, { perHour: data.creditsMeta.pOthers[i].perHour, numCredits: data.creditsMeta.pOthers[i].numCredits }));
							data.creditsLeft += Number.parseInt(data.creditsMeta.pOthers[i].numCredits);
						}
					}
				}

				const postData = {
					mobile: '65' + data.mobile,
					salutation: data.salutation,
					firstname: data.firstname,
					lastname: data.lastname,
					email: data.email,
					creditsLeft: data.creditsLeft,
					otpVerified: data.otpVerified,
					credits: credits
				};

				global.axios.request({
					method: 'post',
					url: '/customers/' + data.id + '/update',
					validateStatus: (status) => {
						return status == 200;
					},
					data: postData
				})
					.then(response => {
						commit('addCustomer', response.data);
						resolve(response);
					})
					.catch(error => reject(error));

			});

		},

		editCustomerForBooking({ commit, state }, data) {
			return new Promise((resolve, reject) => {

				const postData = {
					firstname: data.firstname,
					lastname: data.lastname,
				};

				global.axios.request({
						method: 'post',
						url: '/customers/' + auth.state.id + '/update',
						validateStatus: (status) => {
							return status == 200;
						},
						data: postData
					})
					.then(response => {
						// commit( 'addCustomer', response.data );
						resolve(response);
					})
					.catch(error => reject(error));

			});

		},

		editCustomerNumber({ commit, state }, data) {

			return new Promise((resolve, reject) => {

				const postData = {
					mobile: '65' + data.mobile
				};

				global.axios.request({
						method: 'post',
						url: '/customers/' + data.id + '/update',
						validateStatus: (status) => {
							return status == 200;
						},
						data: postData
					})
					.then(response => {
						// commit( 'addCustomer', response.data );
						resolve(response);
					})
					.catch(error => reject(error));

			});

		},

		/* 
		 *  /DELETE/:id customers API
		 *  Removes an existing customer into the server
		 *  @params: identifier (String)
		 *  @return: 200 OK
		 */
		deleteCustomer({ commit, state }, identifier) {

			return new Promise((resolve, reject) => {

				global.axios.request({
						method: 'post',
						url: '/customers/' + identifier + '/trash',
						validateStatus: (status) => {
							return status == 200;
						}
					})
					.then(response => {
						commit('deleteCustomer', identifier);
						resolve(response);
					})
					.catch(error => reject(error));

			});

		},

		/*
		 *  /POST/signin customers API
		 *  Requests an otp for the number
		 *  @params: Object (phone number and OTP)
		 *  @return: 200 OK
		 */
		sendOtpCustomer({ commit, state }, data) {

			return new Promise((resolve, reject) => {

				const postData = {
					mobile: '65' + data.mobile
				};

				global.axios.request({
						method: 'post',
						url: '/customers/signin',
						data: postData,
						validateStatus: (status) => {
							return status == 200;
						}
					})
					.then(response => {
						resolve(response);
					})
					.catch(error => reject(error));

			});

		},



		sendOtpCustomerfb({ commit, state }, data) {
			return new Promise((resolve, reject) => {
				const postData = {
					mobile: '65' + data.mobile,
					idfb: data.idfb
				};
				global.axios.request({
						method: 'post',
						url: '/customers/signinfb',
						data: postData,
						validateStatus: (status) => {
							return status == 200;
						}
					})
					.then(response => {
						resolve(response);
					})
					.catch(error => reject(error));

			});

		},



		/*
		 *  /POST/register customers API
		 *  Creates a customer account without admin privilege
		 *  @params: Object (customers data)
		 *  @return: Object
		 */
		registerCustomer({ commit, state }, data) {

			return new Promise((resolve, reject) => {

				const postData = {
					mobile: '65' + data.mobile,
					salutation: data.salutation,
					firstname: data.firstname,
					lastname: data.lastname,
					email: data.email,
					otpVerified: data.otpVerified
				};

				global.axios.request({
						method: 'post',
						url: '/customers/register',
						validateStatus: (status) => {
							return status == 201;
						},
						data: postData
					})
					.then(response => {
						commit('addCustomer', response.data);
						resolve(response);
					})
					.catch(error => reject(error));

			});

		},

		/* 
		 *  /POST/:id/untrash customers API
		 *  Restores a customer into the server from the trash
		 *  @params: identifier (String)
		 *  @return: 200 OK
		 */
		untrashCustomer({ commit, state }, identifier) {

			return new Promise((resolve, reject) => {

				global.axios.request({
						method: 'post',
						url: '/customers/' + identifier + '/untrash',
						validateStatus: (status) => {
							return status == 200;
						},
					})
					.then(response => {
						const updatedList = state.customersList.map(item => {
							if (item.id === identifier) {
								let holder = item;
								holder.trash = 0;
								return holder;
							} else {
								return item;
							};
						});
						commit('updateCustomerList', updatedList);
					})
					.catch(error => reject(error));

			});

		},

		updateCreditCard( { commit }, data ) {


			return new Promise (( resolve, reject ) => {
 
				const postData = {
					stripeToken: data.stripeToken
				};


				global.axios.request({
					method: 'post',
					url: '/customers/updateCreditCard',
					validateStatus: ( status ) => { return status == 200; },
					data: postData
				})
				.then(response => {
					resolve(response);
				})
				.catch(error => reject( error ));

			});

		},



		/* 
		 *  /GET customers API CSV
		 *  Get all customers from the server as a CSV
		 *  (different headers)
		 *  @return: Array
		 */
		getCustomersCsv({ commit }) {

			window.open(process.env.ENDPOINT + '/customers/download_csv_file');

		},

		getCustomerAddressesCsv({ commit }) {

			window.open(process.env.ENDPOINT + '/customers-addresses?download=1&from=0&size=9999999');

		},
		getCustomerSingupLog({ commit }) {

			window.open(process.env.ENDPOINT + 'logsignup/download');

		},
		reset({ commit, state }) {
			commit('resetState');
		},
		resetIndex({commit, state}) {
			commit('resetStateIndex');
		},
		/* 
		*  /POST customers API
		*  Add a new join us to the server
		*  @params: Object (join us data)
		*  @return: Object
		*/
		join_us( { commit, state }, data ) {

			return new Promise ( (resolve, reject ) => {

				const postData = {
					firstname: data.firstname,
					lastname: data.lastname,
					phone: data.phone,
					email: data.email,
					gender: data.gender,
					age: data.age,
					experience: data.experience,
					nationality: data.nationality,
					home_area: data.home_area,
					apply_for: data.apply_for,
					message: data.message
				};

				global.axios.request({
					method: 'post',
					url: '/join-us/addnew',
					validateStatus: ( status ) => { return status == 200; },
					data: postData
				})
				.then(response => {
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},			
///
		getCreditsLeftAllCustomers( { commit, state }, data ) {

			return new Promise ( (resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/credits-left/statistics',
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		getFullName( { commit, state }, data ) {

			return new Promise ( (resolve, reject ) => {

				global.axios.request({
					method: 'post',
					url: '/customers/get_fullname',
					validateStatus: ( status ) => { return status == 200; },
					data: {email: data.email}
				})
				.then(response => {
					resolve( response );
				})
				.catch(error => reject( error ));
			});

		},
		sendLogSignup( { commit, dispatch }, data ) {
			function get_user_os(commit) {
				var OSName = "Unknown";
				if (window.navigator.userAgent.indexOf("Windows NT 10.0")!= -1) OSName="Windows 10";
				if (window.navigator.userAgent.indexOf("Windows NT 6.2") != -1) OSName="Windows 8";
				if (window.navigator.userAgent.indexOf("Windows NT 6.1") != -1) OSName="Windows 7";
				if (window.navigator.userAgent.indexOf("Windows NT 6.0") != -1) OSName="Windows Vista";
				if (window.navigator.userAgent.indexOf("Windows NT 5.1") != -1) OSName="Windows XP";
				if (window.navigator.userAgent.indexOf("Windows NT 5.0") != -1) OSName="Windows 2000";
				if (window.navigator.userAgent.indexOf("Mac")            != -1) OSName="Mac/iOS";
				if (window.navigator.userAgent.indexOf("X11")            != -1) OSName="UNIX";
				if (window.navigator.userAgent.indexOf("Linux")          != -1) OSName="Linux";
				return OSName;
			}
			let os = get_user_os();
			return new Promise ( (resolve, reject ) => {
				const postData = {
					os: os,
					salutation: data.salutation ? data.salutation: null,
					firstname: data.firstname ? data.firstname: null,
					lastname: data.lastname ? data.lastname: null,
					phone: data.mobile ? data.mobile: null,
					email: data.email ? data.email: null,
					note: data.note ? data.note: null,
					action: data.action ? data.action: null,
					idfb: data.idfb ? data.idfb: null,
				};
				global.axios.request({
					method: 'post',
					url: '/logsignup/sendlog?XDEBUG_SESSION_START=1',
					validateStatus: ( status ) => { return status == 200; },
					data: postData
				})
				.then(response => {
					resolve( response );
				})
				.catch(error => reject( error ));
			});
		},
	}
}


// WEBPACK FOOTER //
// ./src/custom/controllers/Customers.js